/* ════ NAVIGATION + MINI CALENDAR ══════════════════════════ */
import { state } from './state.js';
import { $, $$ } from './dom.js';
import { MO } from './config.js';
import { addD } from './utils/date.js';
import { buildGantt } from './gantt/index.js';
import { renderCo2 } from './co2board.js';
import { showToast } from './utils/toast.js';

// Redraw whichever timeline board is showing (planner or CO₂).
const redraw = () => { if (state.currentView === 'co2') renderCo2(); else buildGantt(); };
const activeScroll = () => state.currentView === 'co2' ? $('co2-scroll') : $('tl-scroll');

function renderMC() {
  $('mc-year').textContent = state.mcYear;
  const cm = state.viewStart.getMonth(), cy = state.viewStart.getFullYear();
  $('mc-grid').innerHTML = MO.map((m, i) => `<button class="mc-m${i === cm && state.mcYear === cy ? ' cur' : ''}" onclick="jumpToMonth(${state.mcYear},${i})">${m}</button>`).join('');
}

export function jumpToMonth(y, m) {
  state.viewStart = new Date(y, m, 1);
  $('mini-cal').classList.remove('open');
  redraw();
}

// Step the ‹ › arrows by one week on week-scale views (2w/4w/6w), and by the
// full span on month-scale views (3m+), so 2w advances a week, not two.
const navStep = () => state.viewDays <= 42 ? 7 : state.viewDays;

export function initNavigation() {
  $('btn-prev').addEventListener('click', () => { state.viewStart = addD(state.viewStart, -navStep()); redraw(); });
  $('btn-next').addEventListener('click', () => { state.viewStart = addD(state.viewStart, navStep()); redraw(); });
  $('btn-today').addEventListener('click', () => {
    const t = new Date(); t.setHours(0, 0, 0, 0); state.viewStart = addD(t, -5); redraw();
    setTimeout(() => { const s = activeScroll(); if (s) s.scrollLeft = Math.max(0, 5 * state.DAY_W - 60); }, 50);
  });
  $$('.rp').forEach(b => b.addEventListener('click', () => {
    $$('.rp').forEach(x => x.classList.remove('on'));
    b.classList.add('on'); state.viewDays = parseInt(b.dataset.d); redraw();
  }));
  $('period-btn').addEventListener('click', e => {
    e.stopPropagation(); const mc = $('mini-cal');
    mc.classList.toggle('open'); if (mc.classList.contains('open')) { state.mcYear = state.viewStart.getFullYear(); renderMC(); }
  });
  document.addEventListener('click', e => { if (!e.target.closest('#mini-cal') && !e.target.closest('#period-btn')) $('mini-cal').classList.remove('open'); });
  $('mc-prev').addEventListener('click', e => { e.stopPropagation(); state.mcYear--; renderMC(); });
  $('mc-next').addEventListener('click', e => { e.stopPropagation(); state.mcYear++; renderMC(); });

  // Skip-weekends toggle — the label shows which counting mode is active.
  const sw = $('btn-skipwe');
  state.skipWeekends = localStorage.getItem('grantt_skipwe') === '1';
  const paintSW = () => {
    sw.classList.toggle('on', state.skipWeekends);
    sw.innerHTML = state.skipWeekends ? '🗓️<span class="tb-lbl"> Working days</span>' : '📅<span class="tb-lbl"> Calendar days</span>';
    sw.title = state.skipWeekends
      ? 'Counting working days — weekends are skipped, so durations extend over them. Click to count calendar days.'
      : 'Counting calendar days — weekends are included in durations. Click to skip weekends (count working days).';
  };
  paintSW();
  sw.addEventListener('click', () => {
    state.skipWeekends = !state.skipWeekends;
    localStorage.setItem('grantt_skipwe', state.skipWeekends ? '1' : '0');
    paintSW();
    showToast(state.skipWeekends ? '🗓️ Working days — durations now skip weekends' : '📅 Calendar days — weekends included in durations');
  });

  // Rebuild on resize once the app is visible.
  window.addEventListener('resize', () => { if ($('app').classList.contains('on')) redraw(); });
}
